import axios from 'axios';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import { getPassportBiodataValue } from '../../../selectors/travelUg/travelDetails';
import { setPassportDocumentIdValue } from '../../../actions/travelUg/travelDetails';

export const passportUploadService = (store, next, action) => {
    (async () => {
        try {
            const resp = await upload(store.getState());

            store.dispatch(setPassportDocumentIdValue(resp.data.document));
        } catch (e) {
            console.error(e);
            throw e;
        }
    })();
    return next(action);
};

const passportUploadPayload = (state) => {
    const passport = getPassportBiodataValue(state);

    const payload = {
        file: passport?.value?.base64File || 'N/A',
        contentType: passport?.value?.fileType || 'N/A',
        type: 'image',
        name: passport?.value?.fileName,
    };

    return {
        ...payload,
    };
};

const upload = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/travel-ug/upload-file';
        return await axios.post(url, passportUploadPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
